import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { UpdatePartnerRequestUseCaseInterface } from 'domain/usecases';

export class RemoteUpdatePartnerRequest implements UpdatePartnerRequestUseCaseInterface {
  constructor(
    private readonly baseUrl: string,
    private readonly httpClient,
  ) {}

  async execute(params: Parameters<UpdatePartnerRequestUseCaseInterface['execute']>[0]): Promise<UpdatePartnerRequestUseCaseInterface.Result> {
    const { id, ...body } = params;
    const httpResponse = await this.httpClient.request({
      url: `${this.baseUrl}/${id}`,
      method: 'patch',
      body,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
